import { render, staticRenderFns } from "./SellCoinsPurchaseHistory.vue?vue&type=template&id=45f9dddc&scoped=true&"
import script from "./SellCoinsPurchaseHistory.vue?vue&type=script&lang=ts&"
export * from "./SellCoinsPurchaseHistory.vue?vue&type=script&lang=ts&"
import style0 from "./SellCoinsPurchaseHistory.vue?vue&type=style&index=0&id=45f9dddc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f9dddc",
  null
  
)

export default component.exports